var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/polls/poll-option.tsx";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import "core-js/modules/es.array.includes.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classNames from 'clsx';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Motion, presets, spring } from 'react-motion';
import { HStack, Icon, Text } from '../ui';
const messages = defineMessages({
  voted: {
    "id": "poll.voted",
    "defaultMessage": "You voted for this answer"
  },
  votes: {
    "id": "poll.votes",
    "defaultMessage": "{votes, plural, one {# vote} other {# votes}}"
  }
});

const PollPercentageBar = _ref => {
  let {
    percent,
    leading
  } = _ref;
  return /*#__PURE__*/React.createElement(Motion, {
    defaultStyle: {
      width: 0
    },
    style: {
      width: spring(percent, _objectSpread(_objectSpread({}, presets.gentle), {}, {
        precision: 0.1
      }))
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 5
    }
  }, _ref2 => {
    let {
      width
    } = _ref2;
    return /*#__PURE__*/React.createElement("span", {
      className: "absolute inset-0 h-full inline-block bg-primary-100 dark:bg-primary-500 rounded-l-md",
      style: {
        width: "".concat(width, "%")
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 22,
        columnNumber: 9
      }
    });
  });
};

const PollOptionText = _ref3 => {
  let {
    poll,
    option,
    index,
    active,
    onToggle
  } = _ref3;

  const handleOptionChange = () => onToggle(index);

  const handleOptionKeyPress = e => {
    if (e.key === 'Enter' || e.key === ' ') {
      onToggle(index);
      e.stopPropagation();
      e.preventDefault();
    }
  };

  return /*#__PURE__*/React.createElement("label", {
    className: classNames('flex relative p-2 bg-white dark:bg-primary-900 cursor-pointer rounded-3xl border border-solid hover:bg-primary-50 dark:hover:bg-primary-800/50', {
      'border-primary-600 ring-1 ring-primary-600 bg-primary-50 dark:bg-primary-800/50 dark:border-primary-300 dark:ring-primary-300': active,
      'border-primary-300 dark:border-primary-500': !active
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("input", {
    className: "hidden",
    name: "vote-options",
    type: poll.multiple ? 'checkbox' : 'radio',
    value: index,
    checked: active,
    onChange: handleOptionChange,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "grid items-center w-full",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-start-1 row-start-1 justify-self-center ml-4 mr-6",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-primary-600 dark:text-white",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Text, {
    theme: "inherit",
    weight: "medium",
    dangerouslySetInnerHTML: {
      __html: option.title_emojified
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 13
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-start-1 row-start-1 justify-self-end flex items-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames('flex items-center justify-center w-6 h-6 flex-none border border-solid rounded-full', {
      'bg-primary-600 border-primary-600 dark:bg-primary-300 dark:border-primary-300': active,
      'border-primary-300 bg-white dark:bg-primary-900 dark:border-primary-500': !active
    }),
    tabIndex: 0,
    role: poll.multiple ? 'checkbox' : 'radio',
    onKeyPress: handleOptionKeyPress,
    "aria-checked": active,
    "aria-label": option.title,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 11
    }
  }, active && /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/check.svg'),
    className: "text-white dark:text-primary-900 w-4 h-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88,
      columnNumber: 15
    }
  })))));
};

const PollOption = props => {
  var _poll$own_votes;

  const {
    index,
    poll,
    option,
    showResults
  } = props;
  const intl = useIntl();
  if (!poll) return null;
  const pollVotesCount = poll.voters_count || poll.votes_count;
  const percent = pollVotesCount === 0 ? 0 : option.votes_count / pollVotesCount * 100;
  const leading = poll.options.filterNot(other => other.title === option.title).every(other => option.votes_count >= other.votes_count);
  const voted = (_poll$own_votes = poll.own_votes) === null || _poll$own_votes === void 0 ? void 0 : _poll$own_votes.includes(index);
  const message = intl.formatMessage(messages.votes, {
    votes: option.votes_count
  });
  return /*#__PURE__*/React.createElement("div", {
    key: option.title,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 120,
      columnNumber: 5
    }
  }, showResults ? /*#__PURE__*/React.createElement("div", {
    title: voted ? message : undefined,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 122,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    justifyContent: "between",
    alignItems: "center",
    className: "relative p-2 w-full bg-white dark:bg-primary-800 rounded-md overflow-hidden",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 123,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(PollPercentageBar, {
    percent: percent,
    leading: leading,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 128,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-primary-600 dark:text-white",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 130,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Text, {
    theme: "inherit",
    weight: "medium",
    dangerouslySetInnerHTML: {
      __html: option.title_emojified
    },
    className: "relative",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 131,
      columnNumber: 15
    }
  })), /*#__PURE__*/React.createElement(HStack, {
    space: 2,
    alignItems: "center",
    className: "relative",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 139,
      columnNumber: 13
    }
  }, voted ? /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/circle-check.svg'),
    alt: intl.formatMessage(messages.voted),
    className: "text-primary-600 dark:text-primary-800 dark:fill-white w-4 h-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 141,
      columnNumber: 17
    }
  }) : /*#__PURE__*/React.createElement("div", {
    className: "svg-icon",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 147,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-primary-600 dark:text-white",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 150,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "medium",
    theme: "inherit",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 151,
      columnNumber: 17
    }
  }, Math.round(percent), "%"))))) : /*#__PURE__*/React.createElement(PollOptionText, _extends({
    percent: percent
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 157,
      columnNumber: 9
    }
  })));
};

export default PollOption;